import React, { Fragment, useEffect, useState } from "react";
import {
  Button,
  Col,
  Collapse,
  Form,
  Input,
  message,
  Row,
  Select,
  Skeleton,
} from "antd";
import Liens from "./Liens/Liens";
import UCCLiens from "./UCCLiens/UCCLiens";
import Litigation from "./Litigation/Litigation";
import { useQuery } from "../../../../helpers/utility";
import { getOwnershipDetails } from "../../../../services/vendorProfile.services";
import { updateUserAddress } from "../../../../services/adminForm.services";

const { Panel } = Collapse;
const { Option } = Select;
const { TextArea } = Input;
const BackgroundInfo = (props) => {
  const query = useQuery();
  const [form] = Form.useForm();
  let id = query.get("vendorId");
  const [owners, setOwners] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [updateAddressLoading, setUpdateddressLoading] = useState(false);
  useEffect(() => {
    let isMounted = true;
    
    if (id) {
      setLoading(true);
      getOwnershipDetails(id)
        .then((response) => {
          if (!isMounted) return; // Don't update state if component unmounted
          setOwners(response.data.data);
          const firstOwnerId = response.data.data?.[0]?.id;
          setSelectedOwner(firstOwnerId);
          // Set initial form value for the first owner
          if (firstOwnerId && response.data.data?.[0]?.admin_address) {
            form.setFieldsValue({
              admin_address: response.data.data[0].admin_address,
            });
          }
          setLoading(false);
        })
        .catch((error) => {
          if (!isMounted) return; // Don't update state if component unmounted
          console.log(error);
          setLoading(false);
          message.error(error.response?.data.message);
        });
    }
    
    return () => {
      isMounted = false; // Cleanup: mark component as unmounted
    };
  }, [id]);

  function handleChange(value) {
    setSelectedOwner(value);
    // Set the form value when owner changes
    const selectedOwnerData = owners?.find((eachDoc) => eachDoc.id == value);
    form.setFieldsValue({
      admin_address: selectedOwnerData?.admin_address || "",
    });
  }

  async function updateAddress(values) {
    try {
      setUpdateddressLoading(true);
      const res = await updateUserAddress(selectedOwner, values);
      // Update the owners state with the new address
      const selectedUserDetails = owners.find(
        (eachUser) => eachUser.id == selectedOwner
      );
      if (selectedUserDetails) {
        selectedUserDetails.admin_address = res?.data?.admin_address;
      }
      // Update form value to reflect the saved address
      form.setFieldsValue({
        admin_address: res?.data?.admin_address || "",
      });
      message.success("Address updated successfully");
      props.onStepChange?.(props.currentStep + 1);
    } catch (err) {
      console.error(err);
      message.error("Failed to update address, please try again");
    } finally {
      setUpdateddressLoading(false);
    }
  }
  return (
    <Fragment>
      {loading || !owners ? (
        <Skeleton active />
      ) : (
        <Row gutter={[16, 16]}>
          <Col>
            <Select
              size="large"
              onChange={handleChange}
              style={{ minWidth: 200 }}
              placeholder="Choose Owner"
              defaultValue={selectedOwner && selectedOwner}
            >
              {owners?.map((owner) => (
                <Option value={owner?.id} key={owner?.id}>
                  {`${owner?.first_name} ${owner?.last_name}`}
                </Option>
              ))}
            </Select>
          </Col>
          <Col>
            <Form onFinish={updateAddress} form={form}>
              <Form.Item
                name="admin_address"
                rules={[{ required: true, message: "Required!" }]}
              >
                <TextArea
                  key={selectedOwner}
                  autoSize={{ minRows: 2 }}
                  placeholder="Update address"
                  showCount
                  maxLength={500}
                ></TextArea>
              </Form.Item>
              <Button
                style={{
                  marginBottom: "10px",
                }}
                type="primary"
                loading={updateAddressLoading}
                disabled={updateAddressLoading}
                htmlType="submit"
              >
                Save
              </Button>
            </Form>
            <Collapse defaultActiveKey={["1", "2", "3"]}>
              <Panel header="Litigation" key="1">
                <Litigation selectedOwner={selectedOwner && selectedOwner} />
              </Panel>
              <Panel header="Liens" key="2">
                <Liens selectedOwner={selectedOwner && selectedOwner} />
              </Panel>
              <Panel header="UCCLiens" key="3">
                <UCCLiens selectedOwner={selectedOwner && selectedOwner} />
              </Panel>
            </Collapse>
          </Col>
        </Row>
      )}
    </Fragment>
  );
};

export default BackgroundInfo;
